import React from 'react';
import { Grid, Typography, IconButton } from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

const PageHeader = ({ title, externalLink }) => {
  return (
    <Grid container spacing={3} alignItems="center">
      <Grid>
        <Typography variant="body1" color="text.secondary">
          {title}
        </Typography>
      </Grid>
      <Grid>
        <IconButton
          color="primary"
          href={externalLink}
          target="_blank"
          rel="noopener noreferrer"
          size="small"
        >
          <OpenInNewIcon />
        </IconButton>
      </Grid>
    </Grid>
  );
};

export default PageHeader; 